// AUTO GENERATED FILE by snbt.pegjs - DO NOT EDIT
import { base } from './snbt-parser.base';
// @generated by Peggy 4.2.0.
//
// https://peggyjs.org/
function peg$subclass(child, parent) {
    function C() { this.constructor = child; }
    C.prototype = parent.prototype;
    child.prototype = new C();
}
function peg$SyntaxError(message, expected, found, location) {
    var self = Error.call(this, message);
    // istanbul ignore next Check is a necessary evil to support older environments
    if (Object.setPrototypeOf) {
        Object.setPrototypeOf(self, peg$SyntaxError.prototype);
    }
    self.expected = expected;
    self.found = found;
    self.location = location;
    self.name = "SyntaxError";
    return self;
}
peg$subclass(peg$SyntaxError, Error);
function peg$padEnd(str, targetLength, padString) {
    padString = padString || " ";
    if (str.length > targetLength) {
        return str;
    }
    targetLength -= str.length;
    padString += padString.repeat(targetLength);
    return str + padString.slice(0, targetLength);
}
peg$SyntaxError.prototype.format = function (sources) {
    var str = "Error: " + this.message;
    if (this.location) {
        var src = null;
        var k;
        for (k = 0; k < sources.length; k++) {
            if (sources[k].source === this.location.source) {
                src = sources[k].text.split(/\r\n|\n|\r/g);
                break;
            }
        }
        var s = this.location.start;
        var offset_s = (this.location.source && (typeof this.location.source.offset === "function"))
            ? this.location.source.offset(s)
            : s;
        var loc = this.location.source + ":" + offset_s.line + ":" + offset_s.column;
        if (src) {
            var e = this.location.end;
            var filler = peg$padEnd("", offset_s.line.toString().length, ' ');
            var line = src[s.line - 1];
            var last = s.line === e.line ? e.column : line.length + 1;
            var hatLen = (last - s.column) || 1;
            str += "\n --> " + loc + "\n"
                + filler + " |\n"
                + offset_s.line + " | " + line + "\n"
                + filler + " | " + peg$padEnd("", s.column - 1, ' ')
                + peg$padEnd("", hatLen, "^");
        }
        else {
            str += "\n at " + loc;
        }
    }
    return str;
};
peg$SyntaxError.buildMessage = function (expected, found) {
    var DESCRIBE_EXPECTATION_FNS = {
        literal: function (expectation) {
            return "\"" + literalEscape(expectation.text) + "\"";
        },
        class: function (expectation) {
            var escapedParts = expectation.parts.map(function (part) {
                return Array.isArray(part)
                    ? classEscape(part[0]) + "-" + classEscape(part[1])
                    : classEscape(part);
            });
            return "[" + (expectation.inverted ? "^" : "") + escapedParts.join("") + "]";
        },
        any: function () {
            return "any character";
        },
        end: function () {
            return "end of input";
        },
        other: function (expectation) {
            return expectation.description;
        }
    };
    function hex(ch) {
        return ch.charCodeAt(0).toString(16).toUpperCase();
    }
    function literalEscape(s) {
        return s
            .replace(/\\/g, "\\\\")
            .replace(/"/g, "\\\"")
            .replace(/\0/g, "\\0")
            .replace(/\t/g, "\\t")
            .replace(/\n/g, "\\n")
            .replace(/\r/g, "\\r")
            .replace(/[\x00-\x0F]/g, function (ch) { return "\\x0" + hex(ch); })
            .replace(/[\x10-\x1F\x7F-\x9F]/g, function (ch) { return "\\x" + hex(ch); });
    }
    function classEscape(s) {
        return s
            .replace(/\\/g, "\\\\")
            .replace(/\]/g, "\\]")
            .replace(/\^/g, "\\^")
            .replace(/-/g, "\\-")
            .replace(/\0/g, "\\0")
            .replace(/\t/g, "\\t")
            .replace(/\n/g, "\\n")
            .replace(/\r/g, "\\r")
            .replace(/[\x00-\x0F]/g, function (ch) { return "\\x0" + hex(ch); })
            .replace(/[\x10-\x1F\x7F-\x9F]/g, function (ch) { return "\\x" + hex(ch); });
    }
    function describeExpectation(expectation) {
        return DESCRIBE_EXPECTATION_FNS[expectation.type](expectation);
    }
    function describeExpected(expected) {
        var descriptions = expected.map(describeExpectation);
        var i, j;
        descriptions.sort();
        if (descriptions.length > 0) {
            for (i = 1, j = 1; i < descriptions.length; i++) {
                if (descriptions[i - 1] !== descriptions[i]) {
                    descriptions[j] = descriptions[i];
                    j++;
                }
            }
            descriptions.length = j;
        }
        switch (descriptions.length) {
            case 1:
                return descriptions[0];
            case 2:
                return descriptions[0] + " or " + descriptions[1];
            default:
                return descriptions.slice(0, -1).join(", ")
                    + ", or "
                    + descriptions[descriptions.length - 1];
        }
    }
    function describeFound(found) {
        return found ? "\"" + literalEscape(found) + "\"" : "end of input";
    }
    return "Expected " + describeExpected(expected) + " but " + describeFound(found) + " found.";
};
function peg$parse(input, options) {
    options = options !== undefined ? options : {};
    var peg$FAILED = {};
    var peg$source = options.grammarSource;
    var peg$startRuleFunctions = { literal: peg$parseliteral };
    var peg$startRuleFunction = peg$parseliteral;
    var peg$c0 = "0";
    var peg$c1 = ".";
    var peg$c2 = "b";
    var peg$c3 = "s";
    var peg$c4 = "t";
    var peg$c5 = "n";
    var peg$c6 = "f";
    var peg$c7 = "r";
    var peg$c8 = "\\";
    var peg$c9 = "'";
    var peg$c10 = "\"";
    var peg$c11 = "x";
    var peg$c12 = "u";
    var peg$c13 = "U";
    var peg$c14 = "N";
    var peg$c15 = "{";
    var peg$c16 = "}";
    var peg$c17 = ",";
    var peg$c18 = "(";
    var peg$c19 = ")";
    var peg$c20 = ":";
    var peg$c21 = "[";
    var peg$c22 = ";";
    var peg$c23 = "]";
    var peg$r0 = /^[ \t\n\f\r\xA0\u2007\u202F\v\x1C-\x1F]/;
    var peg$r1 = /^[+\-]/;
    var peg$r2 = /^[BILSbils]/;
    var peg$r3 = /^[.0-9\-+]/;
    var peg$r4 = /^[uU]/;
    var peg$r5 = /^[sS]/;
    var peg$r6 = /^[01_]/;
    var peg$r7 = /^[0-9_]/;
    var peg$r8 = /^[0-9a-fA-F_]/;
    var peg$r9 = /^[xX]/;
    var peg$r10 = /^[bB]/;
    var peg$r11 = /^[DFdf]/;
    var peg$r12 = /^[eE]/;
    var peg$r13 = /^['"]/;
    var peg$r14 = /^[0-9A-Fa-f]/;
    var peg$r15 = /^[\-a-zA-Z0-9 ]/;
    var peg$r16 = /^[^"'\\]/;
    var peg$r17 = /^[0-9A-Za-z_.+\-]/;
    var peg$r18 = /^[{]/;
    var peg$r19 = /^[[]/;
    var peg$r20 = /^[BLI]/;
    var peg$e0 = peg$otherExpectation("literal");
    var peg$e1 = peg$otherExpectation("whitespace");
    var peg$e2 = peg$classExpectation([" ", "\t", "\n", "\f", "\r", "\xA0", "\u2007", "\u202F", "\v", ["\x1C", "\x1F"]], false, false);
    var peg$e3 = peg$otherExpectation("sign");
    var peg$e4 = peg$classExpectation(["+", "-"], false, false);
    var peg$e5 = peg$classExpectation(["B", "I", "L", "S", "b", "i", "l", "s"], false, false);
    var peg$e6 = peg$classExpectation([".", ["0", "9"], "-", "+"], false, false);
    var peg$e7 = peg$otherExpectation("integer_suffix");
    var peg$e8 = peg$classExpectation(["u", "U"], false, false);
    var peg$e9 = peg$classExpectation(["s", "S"], false, false);
    var peg$e10 = peg$otherExpectation("binary_numeral_char");
    var peg$e11 = peg$classExpectation(["0", "1", "_"], false, false);
    var peg$e12 = peg$otherExpectation("decimal_numeral_char");
    var peg$e13 = peg$classExpectation([["0", "9"], "_"], false, false);
    var peg$e14 = peg$otherExpectation("hex_numeral_char");
    var peg$e15 = peg$classExpectation([["0", "9"], ["a", "f"], ["A", "F"], "_"], false, false);
    var peg$e16 = peg$otherExpectation("binary_numeral");
    var peg$e17 = peg$otherExpectation("decimal_numeral");
    var peg$e18 = peg$otherExpectation("hex_numeral");
    var peg$e19 = peg$otherExpectation("number_sequence");
    var peg$e20 = peg$literalExpectation("0", false);
    var peg$e21 = peg$classExpectation(["x", "X"], false, false);
    var peg$e22 = peg$classExpectation(["b", "B"], false, false);
    var peg$e23 = peg$otherExpectation("integer_literal");
    var peg$e24 = peg$classExpectation(["D", "F", "d", "f"], false, false);
    var peg$e25 = peg$otherExpectation("float_exponent_part");
    var peg$e26 = peg$classExpectation(["e", "E"], false, false);
    var peg$e27 = peg$otherExpectation("float_whole_part");
    var peg$e28 = peg$otherExpectation("float_fraction_part");
    var peg$e29 = peg$otherExpectation("float_sequence");
    var peg$e30 = peg$literalExpectation(".", false);
    var peg$e31 = peg$otherExpectation("float_literal");
    var peg$e32 = peg$classExpectation(["'", "\""], false, false);
    var peg$e33 = peg$otherExpectation("hexadecimal_literal");
    var peg$e34 = peg$classExpectation([["0", "9"], ["A", "F"], ["a", "f"]], false, false);
    var peg$e35 = peg$otherExpectation("string_hex_2");
    var peg$e36 = peg$otherExpectation("string_hex_4");
    var peg$e37 = peg$otherExpectation("string_hex_8");
    var peg$e38 = peg$otherExpectation("unicode_name");
    var peg$e39 = peg$classExpectation(["-", ["a", "z"], ["A", "Z"], ["0", "9"], " "], false, false);
    var peg$e40 = peg$otherExpectation("string_escape_sequence");
    var peg$e41 = peg$literalExpectation("b", false);
    var peg$e42 = peg$literalExpectation("s", false);
    var peg$e43 = peg$literalExpectation("t", false);
    var peg$e44 = peg$literalExpectation("n", false);
    var peg$e45 = peg$literalExpectation("f", false);
    var peg$e46 = peg$literalExpectation("r", false);
    var peg$e47 = peg$literalExpectation("\\", false);
    var peg$e48 = peg$literalExpectation("'", false);
    var peg$e49 = peg$literalExpectation("\"", false);
    var peg$e50 = peg$literalExpectation("x", false);
    var peg$e51 = peg$literalExpectation("u", false);
    var peg$e52 = peg$literalExpectation("U", false);
    var peg$e53 = peg$literalExpectation("N", false);
    var peg$e54 = peg$literalExpectation("{", false);
    var peg$e55 = peg$literalExpectation("}", false);
    var peg$e56 = peg$otherExpectation("string_plain_contents");
    var peg$e57 = peg$classExpectation(["\"", "'", "\\"], true, false);
    var peg$e58 = peg$otherExpectation("string_contents");
    var peg$e59 = peg$otherExpectation("single_quoted_string_chunk");
    var peg$e60 = peg$otherExpectation("single_quoted_string_contents");
    var peg$e61 = peg$otherExpectation("double_quoted_string_chunk");
    var peg$e62 = peg$otherExpectation("double_quoted_string_contents");
    var peg$e63 = peg$otherExpectation("quoted_string_literal");
    var peg$e64 = peg$otherExpectation("unquoted_string");
    var peg$e65 = peg$classExpectation([["0", "9"], ["A", "Z"], ["a", "z"], "_", ".", "+", "-"], false, false);
    var peg$e66 = peg$otherExpectation("arguments");
    var peg$e67 = peg$literalExpectation(",", false);
    var peg$e68 = peg$otherExpectation("unquoted_string_or_builtin");
    var peg$e69 = peg$literalExpectation("(", false);
    var peg$e70 = peg$literalExpectation(")", false);
    var peg$e71 = peg$classExpectation(["{"], false, false);
    var peg$e72 = peg$otherExpectation("map_key");
    var peg$e73 = peg$otherExpectation("map_entry");
    var peg$e74 = peg$literalExpectation(":", false);
    var peg$e75 = peg$otherExpectation("map_entries");
    var peg$e76 = peg$otherExpectation("map_literal");
    var peg$e77 = peg$classExpectation(["["], false, false);
    var peg$e78 = peg$otherExpectation("list_entries");
    var peg$e79 = peg$otherExpectation("array_prefix");
    var peg$e80 = peg$classExpectation(["B", "L", "I"], false, false);
    var peg$e81 = peg$otherExpectation("int_array_entries");
    var peg$e82 = peg$otherExpectation("list_literal");
    var peg$e83 = peg$literalExpectation("[", false);
    var peg$e84 = peg$literalExpectation(";", false);
    var peg$e85 = peg$literalExpectation("]", false);
    var peg$f0 = function (num) { return num._resolve ? num._resolve() : num; };
    var peg$f1 = function (str) { return str; };
    var peg$f2 = function (map) { return map; };
    var peg$f3 = function (lst) { return lst; };
    var peg$f4 = function (suf) { return { signed: base.SignedPrefix.UNSIGNED, type: base.convertToIntTypeSuffix(suf) }; };
    var peg$f5 = function (suf) { return { signed: base.SignedPrefix.SIGNED, type: base.convertToIntTypeSuffix(suf) }; };
    var peg$f6 = function (suf) { return { signed: null, type: base.convertToIntTypeSuffix(suf) }; };
    var peg$f7 = function (num) { return base.checkNum(num, error); };
    var peg$f8 = function (num) { return base.checkNum(num, error); };
    var peg$f9 = function (num) { return base.checkNum(num, error); };
    var peg$f10 = function (hex) { return { base: base.Base.HEX, value: hex }; };
    var peg$f11 = function (bin) { return { base: base.Base.BIN, value: bin }; };
    var peg$f12 = function (num) { return num; };
    var peg$f13 = function (dec) {
        if (dec.startsWith('0') && dec.length !== 1) {
            error('Leading zeros are not allowed');
        }
        return { base: base.Base.DEC, value: dec };
    };
    var peg$f14 = function (sign, num, suf) {
        return base.convertNum({ sign: sign || base.Sign.PLUS, suffix: suf, ...num }, error);
    };
    var peg$f15 = function (sign, dec) { return { sign: sign || base.Sign.PLUS, value: dec }; };
    var peg$f16 = function (integer, frac, exp, suf) { return { integer, frac, exp, suf: base.convertToFloatTypeSuffix(suf) }; };
    var peg$f17 = function (frac, exp, suf) { return { integer: '0', frac, exp, suf: base.convertToFloatTypeSuffix(suf) }; };
    var peg$f18 = function (integer, exp, suf) { return { integer, frac: '0', exp, suf: base.convertToFloatTypeSuffix(suf) }; };
    var peg$f19 = function (integer, exp, suf) { return { integer, frac: '0', exp, suf: base.convertToFloatTypeSuffix(suf) }; };
    var peg$f20 = function (sign, float) { return base.convertFloat({ sign: sign || base.Sign.PLUS, ...float }, error); };
    var peg$f21 = function () { return '\b'; };
    var peg$f22 = function () { return ' '; };
    var peg$f23 = function () { return '\t'; };
    var peg$f24 = function () { return '\n'; };
    var peg$f25 = function () { return '\f'; };
    var peg$f26 = function () { return '\r'; };
    var peg$f27 = function () { return '\\'; };
    var peg$f28 = function () { return '\''; };
    var peg$f29 = function () { return '"'; };
    var peg$f30 = function (s) { return base.convertHexString(s, error); };
    var peg$f31 = function (s) { return base.convertHexString(s, error); };
    var peg$f32 = function (s) { return base.convertHexString(s, error); };
    var peg$f33 = function (s) { return base.convertUnicodeNameString(s, error); };
    var peg$f34 = function (e) { return e; };
    var peg$f35 = function (s) { return s.join(''); };
    var peg$f36 = function (s) { return s.join(''); };
    var peg$f37 = function (l) { return l; };
    var peg$f38 = function (str, args) { return args; };
    var peg$f39 = function (str, argv) {
        return base.convertUnquotedOrBuiltin(str, argv, error);
    };
    var peg$f40 = function (key, value) { return { [key]: value }; };
    var peg$f41 = function (m) { return m; };
    var peg$f42 = function (entries) {
        return entries?.reduce((acc, cur) => ({ ...acc, ...cur }), {}) ?? {};
    };
    var peg$f43 = function (l) { return l; };
    var peg$f44 = function (i) { return i; };
    var peg$f45 = function (pre, entries) { return base.convertIntList(pre, entries, error); };
    var peg$f46 = function (val) { return val ?? []; };
    var peg$currPos = options.peg$currPos | 0;
    var peg$savedPos = peg$currPos;
    var peg$posDetailsCache = [{ line: 1, column: 1 }];
    var peg$maxFailPos = peg$currPos;
    var peg$maxFailExpected = options.peg$maxFailExpected || [];
    var peg$silentFails = options.peg$silentFails | 0;
    var peg$resultsCache = {};
    var peg$result;
    if (options.startRule) {
        if (!(options.startRule in peg$startRuleFunctions)) {
            throw new Error("Can't start parsing from rule \"" + options.startRule + "\".");
        }
        peg$startRuleFunction = peg$startRuleFunctions[options.startRule];
    }
    function text() {
        return input.substring(peg$savedPos, peg$currPos);
    }
    function offset() {
        return peg$savedPos;
    }
    function range() {
        return {
            source: peg$source,
            start: peg$savedPos,
            end: peg$currPos
        };
    }
    function location() {
        return peg$computeLocation(peg$savedPos, peg$currPos);
    }
    function expected(description, location) {
        location = location !== undefined
            ? location
            : peg$computeLocation(peg$savedPos, peg$currPos);
        throw peg$buildStructuredError([peg$otherExpectation(description)], input.substring(peg$savedPos, peg$currPos), location);
    }
    function error(message, location) {
        location = location !== undefined
            ? location
            : peg$computeLocation(peg$savedPos, peg$currPos);
        throw peg$buildSimpleError(message, location);
    }
    function peg$literalExpectation(text, ignoreCase) {
        return { type: "literal", text: text, ignoreCase: ignoreCase };
    }
    function peg$classExpectation(parts, inverted, ignoreCase) {
        return { type: "class", parts: parts, inverted: inverted, ignoreCase: ignoreCase };
    }
    function peg$anyExpectation() {
        return { type: "any" };
    }
    function peg$endExpectation() {
        return { type: "end" };
    }
    function peg$otherExpectation(description) {
        return { type: "other", description: description };
    }
    function peg$computePosDetails(pos) {
        var details = peg$posDetailsCache[pos];
        var p;
        if (details) {
            return details;
        }
        else {
            if (pos >= peg$posDetailsCache.length) {
                p = peg$posDetailsCache.length - 1;
            }
            else {
                p = pos;
                while (!peg$posDetailsCache[--p]) { }
            }
            details = peg$posDetailsCache[p];
            details = {
                line: details.line,
                column: details.column
            };
            while (p < pos) {
                if (input.charCodeAt(p) === 10) {
                    details.line++;
                    details.column = 1;
                }
                else {
                    details.column++;
                }
                p++;
            }
            peg$posDetailsCache[pos] = details;
            return details;
        }
    }
    function peg$computeLocation(startPos, endPos, offset) {
        var startPosDetails = peg$computePosDetails(startPos);
        var endPosDetails = peg$computePosDetails(endPos);
        var res = {
            source: peg$source,
            start: {
                offset: startPos,
                line: startPosDetails.line,
                column: startPosDetails.column
            },
            end: {
                offset: endPos,
                line: endPosDetails.line,
                column: endPosDetails.column
            }
        };
        if (offset && peg$source && (typeof peg$source.offset === "function")) {
            res.start = peg$source.offset(res.start);
            res.end = peg$source.offset(res.end);
        }
        return res;
    }
    function peg$fail(expected) {
        if (peg$currPos < peg$maxFailPos) {
            return;
        }
        if (peg$currPos > peg$maxFailPos) {
            peg$maxFailPos = peg$currPos;
            peg$maxFailExpected = [];
        }
        peg$maxFailExpected.push(expected);
    }
    function peg$buildSimpleError(message, location) {
        return new peg$SyntaxError(message, null, null, location);
    }
    function peg$buildStructuredError(expected, found, location) {
        return new peg$SyntaxError(peg$SyntaxError.buildMessage(expected, found), expected, found, location);
    }
    function peg$parseliteral() {
        var s0, s1, s2;
        var key = peg$currPos * 47 + 0;
        var cached = peg$resultsCache[key];
        if (cached) {
            peg$currPos = cached.nextPos;
            return cached.result;
        }
        peg$silentFails++;
        s0 = peg$currPos;
        s1 = peg$currPos;
        peg$silentFails++;
        s2 = peg$parsestartNumber();
        peg$silentFails--;
        if (s2 !== peg$FAILED) {
            peg$currPos = s1;
            s1 = undefined;
        }
        else {
            s1 = peg$FAILED;
        }
        if (s1 !== peg$FAILED) {
            s2 = peg$parsefloat();
            if (s2 === peg$FAILED) {
                s2 = peg$parseinteger();
            }
            if (s2 !== peg$FAILED) {
                peg$savedPos = s0;
                s0 = peg$f0(s2);
            }
            else {
                peg$currPos = s0;
                s0 = peg$FAILED;
            }
        }
        else {
            peg$currPos = s0;
            s0 = peg$FAILED;
        }
        if (s0 === peg$FAILED) {
            s0 = peg$currPos;
            s1 = peg$currPos;
            peg$silentFails++;
            s2 = peg$parsequote();
            peg$silentFails--;
            if (s2 !== peg$FAILED) {
                peg$currPos = s1;
                s1 = undefined;
            }
            else {
                s1 = peg$FAILED;
            }
            if (s1 !== peg$FAILED) {
                s2 = peg$parsequotedStringLiteral();
                if (s2 !== peg$FAILED) {
                    peg$savedPos = s0;
                    s0 = peg$f1(s2);
                }
                else {
                    peg$currPos = s0;
                    s0 = peg$FAILED;
                }
            }
            else {
                peg$currPos = s0;
                s0 = peg$FAILED;
            }
            if (s0 === peg$FAILED) {
                s0 = peg$currPos;
                s1 = peg$currPos;
                peg$silentFails++;
                s2 = peg$parsemap();
                peg$silentFails--;
                if (s2 !== peg$FAILED) {
                    peg$currPos = s1;
                    s1 = undefined;
                }
                else {
                    s1 = peg$FAILED;
                }
                if (s1 !== peg$FAILED) {
                    s2 = peg$parsemapLiteral();
                    if (s2 !== peg$FAILED) {
                        peg$savedPos = s0;
                        s0 = peg$f2(s2);
                    }
                    else {
                        peg$currPos = s0;
                        s0 = peg$FAILED;
                    }
                }
                else {
                    peg$currPos = s0;
                    s0 = peg$FAILED;
                }
                if (s0 === peg$FAILED) {
                    s0 = peg$currPos;
                    s1 = peg$currPos;
                    peg$silentFails++;
                    s2 = peg$parselist();
                    peg$silentFails--;
                    if (s2 !== peg$FAILED) {
                        peg$currPos = s1;
                        s1 = undefined;
                    }
                    else {
                        s1 = peg$FAILED;
                    }
                    if (s1 !== peg$FAILED) {
                        s2 = peg$parselistLiteral();
                        if (s2 !== peg$FAILED) {
                            peg$savedPos = s0;
                            s0 = peg$f3(s2);
                        }
                        else {
                            peg$currPos = s0;
                            s0 = peg$FAILED;
                        }
                    }
                    else {
                        peg$currPos = s0;
                        s0 = peg$FAILED;
                    }
                    if (s0 === peg$FAILED) {
                        s0 = peg$parseunquotedStringOrBuiltin();
                    }
                }
            }
        }
        peg$silentFails--;
        if (s0 === peg$FAILED) {
            s1 = peg$FAILED;
            if (peg$silentFails === 0) {
                peg$fail(peg$e0);
            }
        }
        peg$resultsCache[key] = { nextPos: peg$currPos, result: s0 };
        return s0;
    }
    function peg$parse_() {
        var s0, s1;
        var key = peg$currPos * 47 + 1;
        var cached = peg$resultsCache[key];
        if (cached) {
            peg$currPos = cached.nextPos;
            return cached.result;
        }
        peg$silentFails++;
        s0 = [];
        s1 = input.charAt(peg$currPos);
        if (peg$r0.test(s1)) {
            peg$currPos++;
        }
        else {
            s1 = peg$FAILED;
            if (peg$silentFails === 0) {
                peg$fail(peg$e2);
            }
        }
        while (s1 !== peg$FAILED) {
            s0.push(s1);
            s1 = input.charAt(peg$currPos);
            if (peg$r0.test(s1)) {
                peg$currPos++;
            }
            else {
                s1 = peg$FAILED;
                if (peg$silentFails === 0) {
                    peg$fail(peg$e2);
                }
            }
        }
        peg$silentFails--;
        s1 = peg$FAILED;
        if (peg$silentFails === 0) {
            peg$fail(peg$e1);
        }
        peg$resultsCache[key] = { nextPos: peg$currPos, result: s0 };
        return s0;
    }
    function peg$parsesign() {
        var s0, s1;
        var key = peg$currPos * 47 + 2;
        var cached = peg$resultsCache[key];
        if (cached) {
            peg$currPos = cached.nextPos;
            return cached.result;
        }
        peg$silentFails++;
        s0 = input.charAt(peg$currPos);
        if (peg$r1.test(s0)) {
            peg$currPos++;
        }
        else {
            s0 = peg$FAILED;
            if (peg$silentFails === 0) {
                peg$fail(peg$e4);
            }
        }
        peg$silentFails--;
        if (s0 === peg$FAILED) {
            s1 = peg$FAILED;
            if (peg$silentFails === 0) {
                peg$fail(peg$e3);
            }
        }
        peg$resultsCache[key] = { nextPos: peg$currPos, result: s0 };
        return s0;
    }
    function peg$parsenoSignSuffix() {
        var s0;
        var key = peg$currPos * 47 + 3;
        var cached = peg$resultsCache[key];
        if (cached) {
            peg$currPos = cached.nextPos;
            return cached.result;
        }
        s0 = input.charAt(peg$currPos);
        if (peg$r2.test(s0)) {
            peg$currPos++;
        }
        else {
            s0 = peg$FAILED;
            if (peg$silentFails === 0) {
                peg$fail(peg$e5);
            }
        }
        peg$resultsCache[key] = { nextPos: peg$currPos, result: s0 };
        return s0;
    }
    function peg$parsestartNumber() {
        var s0;
        var key = peg$currPos * 47 + 4;
        var cached = peg$resultsCache[key];
        if (cached) {
            peg$currPos = cached.nextPos;
            return cached.result;
        }
        s0 = input.charAt(peg$currPos);
        if (peg$r3.test(s0)) {
            peg$currPos++;
        }
        else {
            s0 = peg$FAILED;
            if (peg$silentFails === 0) {
                peg$fail(peg$e6);
            }
        }
        peg$resultsCache[key] = { nextPos: peg$currPos, result: s0 };
        return s0;
    }
    function peg$parseintSuffix() {
        var s0, s1, s2, s3, s4;
        var key = peg$currPos * 47 + 5;
        var cached = peg$resultsCache[key];
        if (cached) {
            peg$currPos = cached.nextPos;
            return cached.result;
        }
        peg$silentFails++;
        s0 = peg$currPos;
        s1 = input.charAt(peg$currPos);
        if (peg$r4.test(s1)) {
            peg$currPos++;
        }
        else {
            s1 = peg$FAILED;
            if (peg$silentFails === 0) {
                peg$fail(peg$e8);
            }
        }
        if (s1 !== peg$FAILED) {
            s2 = peg$parse_();
            s3 = peg$currPos;
            s4 = peg$parsenoSignSuffix();
            if (s4 === peg$FAILED) {
                s4 = null;
            }
            s3 = input.substring(s3, peg$currPos);
            peg$savedPos = s0;
            s0 = peg$f4(s3);
        }
        else {
            peg$currPos = s0;
            s0 = peg$FAILED;
        }
        if (s0 === peg$FAILED) {
            s0 = peg$currPos;
            s1 = input.charAt(peg$currPos);
            if (peg$r5.test(s1)) {
                peg$currPos++;
            }
            else {
                s1 = peg$FAILED;
                if (peg$silentFails === 0) {
                    peg$fail(peg$e9);
                }
            }
            if (s1 !== peg$FAILED) {
                s2 = peg$parse_();
                s3 = peg$currPos;
                s4 = peg$parsenoSignSuffix();
                if (s4 === peg$FAILED) {
                    s4 = null;
                }
                s3 = input.substring(s3, peg$currPos);
                peg$savedPos = s0;
                s0 = peg$f5(s3);
            }
            else {
                peg$currPos = s0;
                s0 = peg$FAILED;
            }
            if (s0 === peg$FAILED) {
                s0 = peg$currPos;
                s1 = peg$currPos;
                s2 = peg$parsenoSignSuffix();
                if (s2 !== peg$FAILED) {
                    s1 = input.substring(s1, peg$currPos);
                }
                else {
                    s1 = s2;
                }
                if (s1 !== peg$FAILED) {
                    peg$savedPos = s0;
                    s1 = peg$f6(s1);
                }
                s0 = s1;
            }
        }
        peg$silentFails--;
        if (s0 === peg$FAILED) {
            s1 = peg$FAILED;
            if (peg$silentFails === 0) {
                peg$fail(peg$e7);
            }
        }
        peg$resultsCache[key] = { nextPos: peg$currPos, result: s0 };
        return s0;
    }
    function peg$parsebinNumChar() {
        var s0, s1;
        var key = peg$currPos * 47 + 6;
        var cached = peg$resultsCache[key];
        if (cached) {
            peg$currPos = cached.nextPos;
            return cached.result;
        }
        peg$silentFails++;
        s0 = input.charAt(peg$currPos);
        if (peg$r6.test(s0)) {
            peg$currPos++;
        }
        else {
            s0 = peg$FAILED;
            if (peg$silentFails === 0) {
                peg$fail(peg$e11);
            }
        }
        peg$silentFails--;
        if (s0 === peg$FAILED) {
            s1 = peg$FAILED;
            if (peg$silentFails === 0) {
                peg$fail(peg$e10);
            }
        }
        peg$resultsCache[key] = { nextPos: peg$currPos, result: s0 };
        return s0;
    }
    function peg$parsedecNumChar() {
        var s0, s1;
        var key = peg$currPos * 47 + 7;
        var cached = peg$resultsCache[key];
        if (cached) {
            peg$currPos = cached.nextPos;
            return cached.result;
        }
        peg$silentFails++;
        s0 = input.charAt(peg$currPos);
        if (peg$r7.test(s0)) {
            peg$currPos++;
        }
        else {
            s0 = peg$FAILED;
            if (peg$silentFails === 0) {
                peg$fail(peg$e13);
            }
        }
        peg$silentFails--;
        if (s0 === peg$FAILED) {
            s1 = peg$FAILED;
            if (peg$silentFails === 0) {
                peg$fail(peg$e12);
            }
        }
        peg$resultsCache[key] = { nextPos: peg$currPos, result: s0 };
        return s0;
    }
    function peg$parsehexNumChar() {
        var s0, s1;
        var key = peg$currPos * 47 + 8;
        var cached = peg$resultsCache[key];
        if (cached) {
            peg$currPos = cached.nextPos;
            return cached.result;
        }
        peg$silentFails++;
        s0 = input.charAt(peg$currPos);
        if (peg$r8.test(s0)) {
            peg$currPos++;
        }
        else {
            s0 = peg$FAILED;
            if (peg$silentFails === 0) {
                peg$fail(peg$e15);
            }
        }
        peg$silentFails--;
        if (s0 === peg$FAILED) {
            s1 = peg$FAILED;
            if (peg$silentFails === 0) {
                peg$fail(peg$e14);
            }
        }
        peg$resultsCache[key] = { nextPos: peg$currPos, result: s0 };
        return s0;
    }
    function peg$parsebinNum() {
        var s0, s1, s2, s3;
        var key = peg$currPos * 47 + 9;
        var cached = peg$resultsCache[key];
        if (cached) {
            peg$currPos = cached.nextPos;
            return cached.result;
        }
        peg$silentFails++;
        s0 = peg$currPos;
        s1 = peg$currPos;
        s2 = [];
        s3 = peg$parsebinNumChar();
        if (s3 !== peg$FAILED) {
            while (s3 !== peg$FAILED) {
                s2.push(s3);
                s3 = peg$parsebinNumChar();
            }
        }
        else {
            s2 = peg$FAILED;
        }
        if (s2 !== peg$FAILED) {
            s1 = input.substring(s1, peg$currPos);
        }
        else {
            s1 = s2;
        }
        if (s1 !== peg$FAILED) {
            peg$savedPos = s0;
            s1 = peg$f7(s1);
        }
        s0 = s1;
        peg$silentFails--;
        if (s0 === peg$FAILED) {
            s1 = peg$FAILED;
            if (peg$silentFails === 0) {
                peg$fail(peg$e16);
            }
        }
        peg$resultsCache[key] = { nextPos: peg$currPos, result: s0 };
        return s0;
    }
    function peg$parsedecNum() {
        var s0, s1, s2, s3;
        var key = peg$currPos * 47 + 10;
        var cached = peg$resultsCache[key];
        if (cached) {
            peg$currPos = cached.nextPos;
            return cached.result;
        }
        peg$silentFails++;
        s0 = peg$currPos;
        s1 = peg$currPos;
        s2 = [];
        s3 = peg$parsedecNumChar();
        if (s3 !== peg$FAILED) {
            while (s3 !== peg$FAILED) {
                s2.push(s3);
                s3 = peg$parsedecNumChar();
            }
        }
        else {
            s2 = peg$FAILED;
        }
        if (s2 !== peg$FAILED) {
            s1 = input.substring(s1, peg$currPos);
        }
        else {
            s1 = s2;
        }
        if (s1 !== peg$FAILED) {
            peg$savedPos = s0;
            s1 = peg$f8(s1);
        }
        s0 = s1;
        peg$silentFails--;
        if (s0 === peg$FAILED) {
            s1 = peg$FAILED;
            if (peg$silentFails === 0) {
                peg$fail(peg$e17);
            }
        }
        peg$resultsCache[key] = { nextPos: peg$currPos, result: s0 };
        return s0;
    }
    function peg$parsehexNum() {
        var s0, s1, s2, s3;
        var key = peg$currPos * 47 + 11;
        var cached = peg$resultsCache[key];
        if (cached) {
            peg$currPos = cached.nextPos;
            return cached.result;
        }
        peg$silentFails++;
        s0 = peg$currPos;
        s1 = peg$currPos;
        s2 = [];
        s3 = peg$parsehexNumChar();
        if (s3 !== peg$FAILED) {
            while (s3 !== peg$FAILED) {
                s2.push(s3);
                s3 = peg$parsehexNumChar();
            }
        }
        else {
            s2 = peg$FAILED;
        }
        if (s2 !== peg$FAILED) {
            s1 = input.substring(s1, peg$currPos);
        }
        else {
            s1 = s2;
        }
        if (s1 !== peg$FAILED) {
            peg$savedPos = s0;
            s1 = peg$f9(s1);
        }
        s0 = s1;
        peg$silentFails--;
        if (s0 === peg$FAILED) {
            s1 = peg$FAILED;
            if (peg$silentFails === 0) {
                peg$fail(peg$e18);
            }
        }
        peg$resultsCache[key] = { nextPos: peg$currPos, result: s0 };
        return s0;
    }
    function peg$parsenumSeq() {
        var s0, s1, s2, s3, s4, s5, s6;
        var key = peg$currPos * 47 + 12;
        var cached = peg$resultsCache[key];
        if (cached) {
            peg$currPos = cached.nextPos;
            return cached.result;
        }
        peg$silentFails++;
        s0 = peg$currPos;
        if (input.charCodeAt(peg$currPos) === 48) {
            s1 = peg$c0;
            peg$currPos++;
        }
        else {
            s1 = peg$FAILED;
            if (peg$silentFails === 0) {
                peg$fail(peg$e20);
            }
        }
        if (s1 !== peg$FAILED) {
            s2 = peg$parse_();
            s3 = peg$currPos;
            s4 = input.charAt(peg$currPos);
            if (peg$r9.test(s4)) {
                peg$currPos++;
            }
            else {
                s4 = peg$FAILED;
                if (peg$silentFails === 0) {
                    peg$fail(peg$e21);
                }
            }
            if (s4 !== peg$FAILED) {
                s5 = peg$parse_();
                s6 = peg$parsehexNum();
                if (s6 !== peg$FAILED) {
                    peg$savedPos = s3;
                    s3 = peg$f10(s6);
                }
                else {
                    peg$currPos = s3;
                    s3 = peg$FAILED;
                }
            }
            else {
                peg$currPos = s3;
                s3 = peg$FAILED;
            }
            if (s3 === peg$FAILED) {
                s3 = peg$currPos;
                s4 = input.charAt(peg$currPos);
                if (peg$r10.test(s4)) {
                    peg$currPos++;
                }
                else {
                    s4 = peg$FAILED;
                    if (peg$silentFails === 0) {
                        peg$fail(peg$e22);
                    }
                }
                if (s4 !== peg$FAILED) {
                    s5 = peg$parse_();
                    s6 = peg$parsebinNum();
                    if (s6 !== peg$FAILED) {
                        peg$savedPos = s3;
                        s3 = peg$f11(s6);
                    }
                    else {
                        peg$currPos = s3;
                        s3 = peg$FAILED;
                    }
                }
                else {
                    peg$currPos = s3;
                    s3 = peg$FAILED;
                }
            }
            if (s3 !== peg$FAILED) {
                peg$savedPos = s0;
                s0 = peg$f12(s3);
            }
            else {
                peg$currPos = s0;
                s0 = peg$FAILED;
            }
        }
        else {
            peg$currPos = s0;
            s0 = peg$FAILED;
        }
        if (s0 === peg$FAILED) {
            s0 = peg$currPos;
            s1 = peg$parsedecNum();
            if (s1 !== peg$FAILED) {
                peg$savedPos = s0;
                s1 = peg$f13(s1);
            }
            s0 = s1;
        }
        peg$silentFails--;
        if (s0 === peg$FAILED) {
            s1 = peg$FAILED;
            if (peg$silentFails === 0) {
                peg$fail(peg$e19);
            }
        }
        peg$resultsCache[key] = { nextPos: peg$currPos, result: s0 };
        return s0;
    }
    function peg$parseinteger() {
        var s0, s1, s2, s3, s4, s5;
        var key = peg$currPos * 47 + 13;
        var cached = peg$resultsCache[key];
        if (cached) {
            peg$currPos = cached.nextPos;
            return cached.result;
        }
        peg$silentFails++;
        s0 = peg$currPos;
        s1 = peg$parsesign();
        if (s1 === peg$FAILED) {
            s1 = null;
        }
        s2 = peg$parse_();
        s3 = peg$parsenumSeq();
        if (s3 !== peg$FAILED) {
            s4 = peg$parse_();
            s5 = peg$parseintSuffix();
            if (s5 === peg$FAILED) {
                s5 = null;
            }
            peg$savedPos = s0;
            s0 = peg$f14(s1, s3, s5);
        }
        else {
            peg$currPos = s0;
            s0 = peg$FAILED;
        }
        peg$silentFails--;
        if (s0 === peg$FAILED) {
            s1 = peg$FAILED;
            if (peg$silentFails === 0) {
                peg$fail(peg$e23);
            }
        }
        peg$resultsCache[key] = { nextPos: peg$currPos, result: s0 };
        return s0;
    }
    function peg$parsefloatSuffix() {
        var s0;
        var key = peg$currPos * 47 + 14;
        var cached = peg$resultsCache[key];
        if (cached) {
            peg$currPos = cached.nextPos;
            return cached.result;
        }
        s0 = input.charAt(peg$currPos);
        if (peg$r11.test(s0)) {
            peg$currPos++;
        }
        else {
            s0 = peg$FAILED;
            if (peg$silentFails === 0) {
                peg$fail(peg$e24);
            }
        }
        peg$resultsCache[key] = { nextPos: peg$currPos, result: s0 };
        return s0;
    }
    function peg$parsefloatExpPart() {
        var s0, s1, s2, s3, s4, s5;
        var key = peg$currPos * 47 + 15;
        var cached = peg$resultsCache[key];
        if (cached) {
            peg$currPos = cached.nextPos;
            return cached.result;
        }
        peg$silentFails++;
        s0 = peg$currPos;
        s1 = input.charAt(peg$currPos);
        if (peg$r12.test(s1)) {
            peg$currPos++;
        }
        else {
            s1 = peg$FAILED;
            if (peg$silentFails === 0) {
                peg$fail(peg$e26);
            }
        }
        if (s1 !== peg$FAILED) {
            s2 = peg$parse_();
            s3 = peg$parsesign();
            if (s3 === peg$FAILED) {
                s3 = null;
            }
            s4 = peg$parse_();
            s5 = peg$parsedecNum();
            if (s5 !== peg$FAILED) {
                peg$savedPos = s0;
                s0 = peg$f15(s3, s5);
            }
            else {
                peg$currPos = s0;
                s0 = peg$FAILED;
            }
        }
        else {
            peg$currPos = s0;
            s0 = peg$FAILED;
        }
        peg$silentFails--;
        if (s0 === peg$FAILED) {
            s1 = peg$FAILED;
            if (peg$silentFails === 0) {
                peg$fail(peg$e25);
            }
        }
        peg$resultsCache[key] = { nextPos: peg$currPos, result: s0 };
        return s0;
    }
    function peg$parsefloatWholePart() {
        var s0, s1;
        var key = peg$currPos * 47 + 16;
        var cached = peg$resultsCache[key];
        if (cached) {
            peg$currPos = cached.nextPos;
            return cached.result;
        }
        peg$silentFails++;
        s0 = peg$parsedecNum();
        peg$silentFails--;
        if (s0 === peg$FAILED) {
            s1 = peg$FAILED;
            if (peg$silentFails === 0) {
                peg$fail(peg$e27);
            }
        }
        peg$resultsCache[key] = { nextPos: peg$currPos, result: s0 };
        return s0;
    }
    function peg$parsefloatFracPart() {
        var s0, s1;
        var key = peg$currPos * 47 + 17;
        var cached = peg$resultsCache[key];
        if (cached) {
            peg$currPos = cached.nextPos;
            return cached.result;
        }
        peg$silentFails++;
        s0 = peg$parsedecNum();
        peg$silentFails--;
        if (s0 === peg$FAILED) {
            s1 = peg$FAILED;
            if (peg$silentFails === 0) {
                peg$fail(peg$e28);
            }
        }
        peg$resultsCache[key] = { nextPos: peg$currPos, result: s0 };
        return s0;
    }
    function peg$parsefloatSeq() {
        var s0, s1, s2, s3, s4, s5, s6, s7, s8, s9;
        var key = peg$currPos * 47 + 18;
        var cached = peg$resultsCache[key];
        if (cached) {
            peg$currPos = cached.nextPos;
            return cached.result;
        }
        peg$silentFails++;
        s0 = peg$currPos;
        s1 = peg$parsefloatWholePart();
        if (s1 !== peg$FAILED) {
            s2 = peg$parse_();
            if (input.charCodeAt(peg$currPos) === 46) {
                s3 = peg$c1;
                peg$currPos++;
            }
            else {
                s3 = peg$FAILED;
                if (peg$silentFails === 0) {
                    peg$fail(peg$e30);
                }
            }
            if (s3 !== peg$FAILED) {
                s4 = peg$parse_();
                s5 = peg$parsefloatFracPart();
                if (s5 === peg$FAILED) {
                    s5 = null;
                }
                s6 = peg$parse_();
                s7 = peg$parsefloatExpPart();
                if (s7 === peg$FAILED) {
                    s7 = null;
                }
                s8 = peg$parse_();
                s9 = peg$parsefloatSuffix();
                if (s9 === peg$FAILED) {
                    s9 = null;
                }
                peg$savedPos = s0;
                s0 = peg$f16(s1, s5, s7, s9);
            }
            else {
                peg$currPos = s0;
                s0 = peg$FAILED;
            }
        }
        else {
            peg$currPos = s0;
            s0 = peg$FAILED;
        }
        if (s0 === peg$FAILED) {
            s0 = peg$currPos;
            if (input.charCodeAt(peg$currPos) === 46) {
                s1 = peg$c1;
                peg$currPos++;
            }
            else {
                s1 = peg$FAILED;
                if (peg$silentFails === 0) {
                    peg$fail(peg$e30);
                }
            }
            if (s1 !== peg$FAILED) {
                s2 = peg$parse_();
                s3 = peg$parsefloatFracPart();
                if (s3 !== peg$FAILED) {
                    s4 = peg$parse_();
                    s5 = peg$parsefloatExpPart();
                    if (s5 === peg$FAILED) {
                        s5 = null;
                    }
                    s6 = peg$parse_();
                    s7 = peg$parsefloatSuffix();
                    if (s7 === peg$FAILED) {
                        s7 = null;
                    }
                    peg$savedPos = s0;
                    s0 = peg$f17(s3, s5, s7);
                }
                else {
                    peg$currPos = s0;
                    s0 = peg$FAILED;
                }
            }
            else {
                peg$currPos = s0;
                s0 = peg$FAILED;
            }
            if (s0 === peg$FAILED) {
                s0 = peg$currPos;
                s1 = peg$parsefloatWholePart();
                if (s1 !== peg$FAILED) {
                    s2 = peg$parse_();
                    s3 = peg$parsefloatExpPart();
                    if (s3 !== peg$FAILED) {
                        s4 = peg$parse_();
                        s5 = peg$parsefloatSuffix();
                        if (s5 === peg$FAILED) {
                            s5 = null;
                        }
                        peg$savedPos = s0;
                        s0 = peg$f18(s1, s3, s5);
                    }
                    else {
                        peg$currPos = s0;
                        s0 = peg$FAILED;
                    }
                }
                else {
                    peg$currPos = s0;
                    s0 = peg$FAILED;
                }
                if (s0 === peg$FAILED) {
                    s0 = peg$currPos;
                    s1 = peg$parsefloatWholePart();
                    if (s1 !== peg$FAILED) {
                        s2 = peg$parse_();
                        s3 = peg$parsefloatExpPart();
                        if (s3 === peg$FAILED) {
                            s3 = null;
                        }
                        s4 = peg$parse_();
                        s5 = peg$parsefloatSuffix();
                        if (s5 !== peg$FAILED) {
                            peg$savedPos = s0;
                            s0 = peg$f19(s1, s3, s5);
                        }
                        else {
                            peg$currPos = s0;
                            s0 = peg$FAILED;
                        }
                    }
                    else {
                        peg$currPos = s0;
                        s0 = peg$FAILED;
                    }
                }
            }
        }
        peg$silentFails--;
        if (s0 === peg$FAILED) {
            s1 = peg$FAILED;
            if (peg$silentFails === 0) {
                peg$fail(peg$e29);
            }
        }
        peg$resultsCache[key] = { nextPos: peg$currPos, result: s0 };
        return s0;
    }
    function peg$parsefloat() {
        var s0, s1, s2, s3;
        var key = peg$currPos * 47 + 19;
        var cached = peg$resultsCache[key];
        if (cached) {
            peg$currPos = cached.nextPos;
            return cached.result;
        }
        peg$silentFails++;
        s0 = peg$currPos;
        s1 = peg$parsesign();
        if (s1 === peg$FAILED) {
            s1 = null;
        }
        s2 = peg$parse_();
        s3 = peg$parsefloatSeq();
        if (s3 !== peg$FAILED) {
            peg$savedPos = s0;
            s0 = peg$f20(s1, s3);
        }
        else {
            peg$currPos = s0;
            s0 = peg$FAILED;
        }
        peg$silentFails--;
        if (s0 === peg$FAILED) {
            s1 = peg$FAILED;
            if (peg$silentFails === 0) {
                peg$fail(peg$e31);
            }
        }
        peg$resultsCache[key] = { nextPos: peg$currPos, result: s0 };
        return s0;
    }
    function peg$parsequote() {
        var s0;
        var key = peg$currPos * 47 + 20;
        var cached = peg$resultsCache[key];
        if (cached) {
            peg$currPos = cached.nextPos;
            return cached.result;
        }
        s0 = input.charAt(peg$currPos);
        if (peg$r13.test(s0)) {
            peg$currPos++;
        }
        else {
            s0 = peg$FAILED;
            if (peg$silentFails === 0) {
                peg$fail(peg$e32);
            }
        }
        peg$resultsCache[key] = { nextPos: peg$currPos, result: s0 };
        return s0;
    }
    function peg$parsehexLiteral() {
        var s0, s1;
        var key = peg$currPos * 47 + 21;
        var cached = peg$resultsCache[key];
        if (cached) {
            peg$currPos = cached.nextPos;
            return cached.result;
        }
        peg$silentFails++;
        s0 = input.charAt(peg$currPos);
        if (peg$r14.test(s0)) {
            peg$currPos++;
        }
        else {
            s0 = peg$FAILED;
            if (peg$silentFails === 0) {
                peg$fail(peg$e34);
            }
        }
        peg$silentFails--;
        if (s0 === peg$FAILED) {
            s1 = peg$FAILED;
            if (peg$silentFails === 0) {
                peg$fail(peg$e33);
            }
        }
        peg$resultsCache[key] = { nextPos: peg$currPos, result: s0 };
        return s0;
    }
    function peg$parsestringHex2() {
        var s0, s1, s2;
        var key = peg$currPos * 47 + 22;
        var cached = peg$resultsCache[key];
        if (cached) {
            peg$currPos = cached.nextPos;
            return cached.result;
        }
        peg$silentFails++;
        s0 = peg$currPos;
        s1 = [];
        s2 = peg$parsehexLiteral();
        while (s2 !== peg$FAILED) {
            s1.push(s2);
            if (s1.length >= 2) {
                s2 = peg$FAILED;
            }
            else {
                s2 = peg$parsehexLiteral();
            }
        }
        if (s1.length < 2) {
            peg$currPos = s0;
            s0 = peg$FAILED;
        }
        else {
            s0 = s1;
        }
        peg$silentFails--;
        if (s0 === peg$FAILED) {
            s1 = peg$FAILED;
            if (peg$silentFails === 0) {
                peg$fail(peg$e35);
            }
        }
        peg$resultsCache[key] = { nextPos: peg$currPos, result: s0 };
        return s0;
    }
    function peg$parsestringHex4() {
        var s0, s1, s2;
        var key = peg$currPos * 47 + 23;
        var cached = peg$resultsCache[key];
        if (cached) {
            peg$currPos = cached.nextPos;
            return cached.result;
        }
        peg$silentFails++;
        s0 = peg$currPos;
        s1 = [];
        s2 = peg$parsehexLiteral();
        while (s2 !== peg$FAILED) {
            s1.push(s2);
            if (s1.length >= 4) {
                s2 = peg$FAILED;
            }
            else {
                s2 = peg$parsehexLiteral();
            }
        }
        if (s1.length < 4) {
            peg$currPos = s0;
            s0 = peg$FAILED;
        }
        else {
            s0 = s1;
        }
        peg$silentFails--;
        if (s0 === peg$FAILED) {
            s1 = peg$FAILED;
            if (peg$silentFails === 0) {
                peg$fail(peg$e36);
            }
        }
        peg$resultsCache[key] = { nextPos: peg$currPos, result: s0 };
        return s0;
    }
    function peg$parsestringHex8() {
        var s0, s1, s2;
        var key = peg$currPos * 47 + 24;
        var cached = peg$resultsCache[key];
        if (cached) {
            peg$currPos = cached.nextPos;
            return cached.result;
        }
        peg$silentFails++;
        s0 = peg$currPos;
        s1 = [];
        s2 = peg$parsehexLiteral();
        while (s2 !== peg$FAILED) {
            s1.push(s2);
            if (s1.length >= 8) {
                s2 = peg$FAILED;
            }
            else {
                s2 = peg$parsehexLiteral();
            }
        }
        if (s1.length < 8) {
            peg$currPos = s0;
            s0 = peg$FAILED;
        }
        else {
            s0 = s1;
        }
        peg$silentFails--;
        if (s0 === peg$FAILED) {
            s1 = peg$FAILED;
            if (peg$silentFails === 0) {
                peg$fail(peg$e37);
            }
        }
        peg$resultsCache[key] = { nextPos: peg$currPos, result: s0 };
        return s0;
    }
    function peg$parseunicodeName() {
        var s0, s1;
        var key = peg$currPos * 47 + 25;
        var cached = peg$resultsCache[key];
        if (cached) {
            peg$currPos = cached.nextPos;
            return cached.result;
        }
        peg$silentFails++;
        s0 = [];
        s1 = input.charAt(peg$currPos);
        if (peg$r15.test(s1)) {
            peg$currPos++;
        }
        else {
            s1 = peg$FAILED;
            if (peg$silentFails === 0) {
                peg$fail(peg$e39);
            }
        }
        if (s1 !== peg$FAILED) {
            while (s1 !== peg$FAILED) {
                s0.push(s1);
                s1 = input.charAt(peg$currPos);
                if (peg$r15.test(s1)) {
                    peg$currPos++;
                }
                else {
                    s1 = peg$FAILED;
                    if (peg$silentFails === 0) {
                        peg$fail(peg$e39);
                    }
                }
            }
        }
        else {
            s0 = peg$FAILED;
        }
        peg$silentFails--;
        if (s0 === peg$FAILED) {
            s1 = peg$FAILED;
            if (peg$silentFails === 0) {
                peg$fail(peg$e38);
            }
        }
        peg$resultsCache[key] = { nextPos: peg$currPos, result: s0 };
        return s0;
    }
    function peg$parsestringEscapeSeq() {
        var s0, s1, s2, s3, s4;
        var key = peg$currPos * 47 + 26;
        var cached = peg$resultsCache[key];
        if (cached) {
            peg$currPos = cached.nextPos;
            return cached.result;
        }
        peg$silentFails++;
        s0 = peg$currPos;
        if (input.charCodeAt(peg$currPos) === 98) {
            s1 = peg$c2;
            peg$currPos++;
        }
        else {
            s1 = peg$FAILED;
            if (peg$silentFails === 0) {
                peg$fail(peg$e41);
            }
        }
        if (s1 !== peg$FAILED) {
            peg$savedPos = s0;
            s1 = peg$f21();
        }
        s0 = s1;
        if (s0 === peg$FAILED) {
            s0 = peg$currPos;
            if (input.charCodeAt(peg$currPos) === 115) {
                s1 = peg$c3;
                peg$currPos++;
            }
            else {
                s1 = peg$FAILED;
                if (peg$silentFails === 0) {
                    peg$fail(peg$e42);
                }
            }
            if (s1 !== peg$FAILED) {
                peg$savedPos = s0;
                s1 = peg$f22();
            }
            s0 = s1;
            if (s0 === peg$FAILED) {
                s0 = peg$currPos;
                if (input.charCodeAt(peg$currPos) === 116) {
                    s1 = peg$c4;
                    peg$currPos++;
                }
                else {
                    s1 = peg$FAILED;
                    if (peg$silentFails === 0) {
                        peg$fail(peg$e43);
                    }
                }
                if (s1 !== peg$FAILED) {
                    peg$savedPos = s0;
                    s1 = peg$f23();
                }
                s0 = s1;
                if (s0 === peg$FAILED) {
                    s0 = peg$currPos;
                    if (input.charCodeAt(peg$currPos) === 110) {
                        s1 = peg$c5;
                        peg$currPos++;
                    }
                    else {
                        s1 = peg$FAILED;
                        if (peg$silentFails === 0) {
                            peg$fail(peg$e44);
                        }
                    }
                    if (s1 !== peg$FAILED) {
                        peg$savedPos = s0;
                        s1 = peg$f24();
                    }
                    s0 = s1;
                    if (s0 === peg$FAILED) {
                        s0 = peg$currPos;
                        if (input.charCodeAt(peg$currPos) === 102) {
                            s1 = peg$c6;
                            peg$currPos++;
                        }
                        else {
                            s1 = peg$FAILED;
                            if (peg$silentFails === 0) {
                                peg$fail(peg$e45);
                            }
                        }
                        if (s1 !== peg$FAILED) {
                            peg$savedPos = s0;
                            s1 = peg$f25();
                        }
                        s0 = s1;
                        if (s0 === peg$FAILED) {
                            s0 = peg$currPos;
                            if (input.charCodeAt(peg$currPos) === 114) {
                                s1 = peg$c7;
                                peg$currPos++;
                            }
                            else {
                                s1 = peg$FAILED;
                                if (peg$silentFails === 0) {
                                    peg$fail(peg$e46);
                                }
                            }
                            if (s1 !== peg$FAILED) {
                                peg$savedPos = s0;
                                s1 = peg$f26();
                            }
                            s0 = s1;
                            if (s0 === peg$FAILED) {
                                s0 = peg$currPos;
                                if (input.charCodeAt(peg$currPos) === 92) {
                                    s1 = peg$c8;
                                    peg$currPos++;
                                }
                                else {
                                    s1 = peg$FAILED;
                                    if (peg$silentFails === 0) {
                                        peg$fail(peg$e47);
                                    }
                                }
                                if (s1 !== peg$FAILED) {
                                    peg$savedPos = s0;
                                    s1 = peg$f27();
                                }
                                s0 = s1;
                                if (s0 === peg$FAILED) {
                                    s0 = peg$currPos;
                                    if (input.charCodeAt(peg$currPos) === 39) {
                                        s1 = peg$c9;
                                        peg$currPos++;
                                    }
                                    else {
                                        s1 = peg$FAILED;
                                        if (peg$silentFails === 0) {
                                            peg$fail(peg$e48);
                                        }
                                    }
                                    if (s1 !== peg$FAILED) {
                                        peg$savedPos = s0;
                                        s1 = peg$f28();
                                    }
                                    s0 = s1;
                                    if (s0 === peg$FAILED) {
                                        s0 = peg$currPos;
                                        if (input.charCodeAt(peg$currPos) === 34) {
                                            s1 = peg$c10;
                                            peg$currPos++;
                                        }
                                        else {
                                            s1 = peg$FAILED;
                                            if (peg$silentFails === 0) {
                                                peg$fail(peg$e49);
                                            }
                                        }
                                        if (s1 !== peg$FAILED) {
                                            peg$savedPos = s0;
                                            s1 = peg$f29();
                                        }
                                        s0 = s1;
                                        if (s0 === peg$FAILED) {
                                            s0 = peg$currPos;
                                            if (input.charCodeAt(peg$currPos) === 120) {
                                                s1 = peg$c11;
                                                peg$currPos++;
                                            }
                                            else {
                                                s1 = peg$FAILED;
                                                if (peg$silentFails === 0) {
                                                    peg$fail(peg$e50);
                                                }
                                            }
                                            if (s1 !== peg$FAILED) {
                                                s2 = peg$currPos;
                                                s3 = peg$parsestringHex2();
                                                if (s3 !== peg$FAILED) {
                                                    s2 = input.substring(s2, peg$currPos);
                                                }
                                                else {
                                                    s2 = s3;
                                                }
                                                if (s2 !== peg$FAILED) {
                                                    peg$savedPos = s0;
                                                    s0 = peg$f30(s2);
                                                }
                                                else {
                                                    peg$currPos = s0;
                                                    s0 = peg$FAILED;
                                                }
                                            }
                                            else {
                                                peg$currPos = s0;
                                                s0 = peg$FAILED;
                                            }
                                            if (s0 === peg$FAILED) {
                                                s0 = peg$currPos;
                                                if (input.charCodeAt(peg$currPos) === 117) {
                                                    s1 = peg$c12;
                                                    peg$currPos++;
                                                }
                                                else {
                                                    s1 = peg$FAILED;
                                                    if (peg$silentFails === 0) {
                                                        peg$fail(peg$e51);
                                                    }
                                                }
                                                if (s1 !== peg$FAILED) {
                                                    s2 = peg$currPos;
                                                    s3 = peg$parsestringHex4();
                                                    if (s3 !== peg$FAILED) {
                                                        s2 = input.substring(s2, peg$currPos);
                                                    }
                                                    else {
                                                        s2 = s3;
                                                    }
                                                    if (s2 !== peg$FAILED) {
                                                        peg$savedPos = s0;
                                                        s0 = peg$f31(s2);
                                                    }
                                                    else {
                                                        peg$currPos = s0;
                                                        s0 = peg$FAILED;
                                                    }
                                                }
                                                else {
                                                    peg$currPos = s0;
                                                    s0 = peg$FAILED;
                                                }
                                                if (s0 === peg$FAILED) {
                                                    s0 = peg$currPos;
                                                    if (input.charCodeAt(peg$currPos) === 85) {
                                                        s1 = peg$c13;
                                                        peg$currPos++;
                                                    }
                                                    else {
                                                        s1 = peg$FAILED;
                                                        if (peg$silentFails === 0) {
                                                            peg$fail(peg$e52);
                                                        }
                                                    }
                                                    if (s1 !== peg$FAILED) {
                                                        s2 = peg$currPos;
                                                        s3 = peg$parsestringHex8();
                                                        if (s3 !== peg$FAILED) {
                                                            s2 = input.substring(s2, peg$currPos);
                                                        }
                                                        else {
                                                            s2 = s3;
                                                        }
                                                        if (s2 !== peg$FAILED) {
                                                            peg$savedPos = s0;
                                                            s0 = peg$f32(s2);
                                                        }
                                                        else {
                                                            peg$currPos = s0;
                                                            s0 = peg$FAILED;
                                                        }
                                                    }
                                                    else {
                                                        peg$currPos = s0;
                                                        s0 = peg$FAILED;
                                                    }
                                                    if (s0 === peg$FAILED) {
                                                        s0 = peg$currPos;
                                                        if (input.charCodeAt(peg$currPos) === 78) {
                                                            s1 = peg$c14;
                                                            peg$currPos++;
                                                        }
                                                        else {
                                                            s1 = peg$FAILED;
                                                            if (peg$silentFails === 0) {
                                                                peg$fail(peg$e53);
                                                            }
                                                        }
                                                        if (s1 !== peg$FAILED) {
                                                            if (input.charCodeAt(peg$currPos) === 123) {
                                                                s2 = peg$c15;
                                                                peg$currPos++;
                                                            }
                                                            else {
                                                                s2 = peg$FAILED;
                                                                if (peg$silentFails === 0) {
                                                                    peg$fail(peg$e54);
                                                                }
                                                            }
                                                            if (s2 !== peg$FAILED) {
                                                                s3 = peg$currPos;
                                                                s4 = peg$parseunicodeName();
                                                                if (s4 !== peg$FAILED) {
                                                                    s3 = input.substring(s3, peg$currPos);
                                                                }
                                                                else {
                                                                    s3 = s4;
                                                                }
                                                                if (s3 !== peg$FAILED) {
                                                                    if (input.charCodeAt(peg$currPos) === 125) {
                                                                        s4 = peg$c16;
                                                                        peg$currPos++;
                                                                    }
                                                                    else {
                                                                        s4 = peg$FAILED;
                                                                        if (peg$silentFails === 0) {
                                                                            peg$fail(peg$e55);
                                                                        }
                                                                    }
                                                                    if (s4 !== peg$FAILED) {
                                                                        peg$savedPos = s0;
                                                                        s0 = peg$f33(s3);
                                                                    }
                                                                    else {
                                                                        peg$currPos = s0;
                                                                        s0 = peg$FAILED;
                                                                    }
                                                                }
                                                                else {
                                                                    peg$currPos = s0;
                                                                    s0 = peg$FAILED;
                                                                }
                                                            }
                                                            else {
                                                                peg$currPos = s0;
                                                                s0 = peg$FAILED;
                                                            }
                                                        }
                                                        else {
                                                            peg$currPos = s0;
                                                            s0 = peg$FAILED;
                                                        }
                                                    }
                                                }
                                            }
                                        }
                                    }
                                }
                            }
                        }
                    }
                }
            }
        }
        peg$silentFails--;
        if (s0 === peg$FAILED) {
            s1 = peg$FAILED;
            if (peg$silentFails === 0) {
                peg$fail(peg$e40);
            }
        }
        peg$resultsCache[key] = { nextPos: peg$currPos, result: s0 };
        return s0;
    }
    function peg$parsestringPlainContents() {
        var s0, s1;
        var key = peg$currPos * 47 + 27;
        var cached = peg$resultsCache[key];
        if (cached) {
            peg$currPos = cached.nextPos;
            return cached.result;
        }
        peg$silentFails++;
        s0 = [];
        s1 = input.charAt(peg$currPos);
        if (peg$r16.test(s1)) {
            peg$currPos++;
        }
        else {
            s1 = peg$FAILED;
            if (peg$silentFails === 0) {
                peg$fail(peg$e57);
            }
        }
        if (s1 !== peg$FAILED) {
            while (s1 !== peg$FAILED) {
                s0.push(s1);
                s1 = input.charAt(peg$currPos);
                if (peg$r16.test(s1)) {
                    peg$currPos++;
                }
                else {
                    s1 = peg$FAILED;
                    if (peg$silentFails === 0) {
                        peg$fail(peg$e57);
                    }
                }
            }
        }
        else {
            s0 = peg$FAILED;
        }
        peg$silentFails--;
        if (s0 === peg$FAILED) {
            s1 = peg$FAILED;
            if (peg$silentFails === 0) {
                peg$fail(peg$e56);
            }
        }
        peg$resultsCache[key] = { nextPos: peg$currPos, result: s0 };
        return s0;
    }
    function peg$parsestringContents() {
        var s0, s1, s2;
        var key = peg$currPos * 47 + 28;
        var cached = peg$resultsCache[key];
        if (cached) {
            peg$currPos = cached.nextPos;
            return cached.result;
        }
        peg$silentFails++;
        s0 = peg$currPos;
        s1 = peg$parsestringPlainContents();
        if (s1 !== peg$FAILED) {
            s0 = input.substring(s0, peg$currPos);
        }
        else {
            s0 = s1;
        }
        if (s0 === peg$FAILED) {
            s0 = peg$currPos;
            if (input.charCodeAt(peg$currPos) === 92) {
                s1 = peg$c8;
                peg$currPos++;
            }
            else {
                s1 = peg$FAILED;
                if (peg$silentFails === 0) {
                    peg$fail(peg$e47);
                }
            }
            if (s1 !== peg$FAILED) {
                s2 = peg$parsestringEscapeSeq();
                if (s2 !== peg$FAILED) {
                    peg$savedPos = s0;
                    s0 = peg$f34(s2);
                }
                else {
                    peg$currPos = s0;
                    s0 = peg$FAILED;
                }
            }
            else {
                peg$currPos = s0;
                s0 = peg$FAILED;
            }
        }
        peg$silentFails--;
        if (s0 === peg$FAILED) {
            s1 = peg$FAILED;
            if (peg$silentFails === 0) {
                peg$fail(peg$e58);
            }
        }
        peg$resultsCache[key] = { nextPos: peg$currPos, result: s0 };
        return s0;
    }
    function peg$parsesingleQuotedStringChunk() {
        var s0, s1;
        var key = peg$currPos * 47 + 29;
        var cached = peg$resultsCache[key];
        if (cached) {
            peg$currPos = cached.nextPos;
            return cached.result;
        }
        peg$silentFails++;
        s0 = peg$parsestringContents();
        if (s0 === peg$FAILED) {
            if (input.charCodeAt(peg$currPos) === 34) {
                s0 = peg$c10;
                peg$currPos++;
            }
            else {
                s0 = peg$FAILED;
                if (peg$silentFails === 0) {
                    peg$fail(peg$e49);
                }
            }
        }
        peg$silentFails--;
        if (s0 === peg$FAILED) {
            s1 = peg$FAILED;
            if (peg$silentFails === 0) {
                peg$fail(peg$e59);
            }
        }
        peg$resultsCache[key] = { nextPos: peg$currPos, result: s0 };
        return s0;
    }
    function peg$parsesingleQuotedStringContents() {
        var s0, s1;
        var key = peg$currPos * 47 + 30;
        var cached = peg$resultsCache[key];
        if (cached) {
            peg$currPos = cached.nextPos;
            return cached.result;
        }
        peg$silentFails++;
        s0 = [];
        s1 = peg$parsesingleQuotedStringChunk();
        while (s1 !== peg$FAILED) {
            s0.push(s1);
            s1 = peg$parsesingleQuotedStringChunk();
        }
        peg$silentFails--;
        s1 = peg$FAILED;
        if (peg$silentFails === 0) {
            peg$fail(peg$e60);
        }
        peg$resultsCache[key] = { nextPos: peg$currPos, result: s0 };
        return s0;
    }
    function peg$parsedoubleQuotedStringChunk() {
        var s0, s1;
        var key = peg$currPos * 47 + 31;
        var cached = peg$resultsCache[key];
        if (cached) {
            peg$currPos = cached.nextPos;
            return cached.result;
        }
        peg$silentFails++;
        s0 = peg$parsestringContents();
        if (s0 === peg$FAILED) {
            if (input.charCodeAt(peg$currPos) === 39) {
                s0 = peg$c9;
                peg$currPos++;
            }
            else {
                s0 = peg$FAILED;
                if (peg$silentFails === 0) {
                    peg$fail(peg$e48);
                }
            }
        }
        peg$silentFails--;
        if (s0 === peg$FAILED) {
            s1 = peg$FAILED;
            if (peg$silentFails === 0) {
                peg$fail(peg$e61);
            }
        }
        peg$resultsCache[key] = { nextPos: peg$currPos, result: s0 };
        return s0;
    }
    function peg$parsedoubleQuotedStringContents() {
        var s0, s1;
        var key = peg$currPos * 47 + 32;
        var cached = peg$resultsCache[key];
        if (cached) {
            peg$currPos = cached.nextPos;
            return cached.result;
        }
        peg$silentFails++;
        s0 = [];
        s1 = peg$parsedoubleQuotedStringChunk();
        while (s1 !== peg$FAILED) {
            s0.push(s1);
            s1 = peg$parsedoubleQuotedStringChunk();
        }
        peg$silentFails--;
        s1 = peg$FAILED;
        if (peg$silentFails === 0) {
            peg$fail(peg$e62);
        }
        peg$resultsCache[key] = { nextPos: peg$currPos, result: s0 };
        return s0;
    }
    function peg$parsequotedStringLiteral() {
        var s0, s1, s2, s3;
        var key = peg$currPos * 47 + 33;
        var cached = peg$resultsCache[key];
        if (cached) {
            peg$currPos = cached.nextPos;
            return cached.result;
        }
        peg$silentFails++;
        s0 = peg$currPos;
        if (input.charCodeAt(peg$currPos) === 34) {
            s1 = peg$c10;
            peg$currPos++;
        }
        else {
            s1 = peg$FAILED;
            if (peg$silentFails === 0) {
                peg$fail(peg$e49);
            }
        }
        if (s1 !== peg$FAILED) {
            s2 = peg$parsedoubleQuotedStringContents();
            if (input.charCodeAt(peg$currPos) === 34) {
                s3 = peg$c10;
                peg$currPos++;
            }
            else {
                s3 = peg$FAILED;
                if (peg$silentFails === 0) {
                    peg$fail(peg$e49);
                }
            }
            if (s3 !== peg$FAILED) {
                peg$savedPos = s0;
                s0 = peg$f35(s2);
            }
            else {
                peg$currPos = s0;
                s0 = peg$FAILED;
            }
        }
        else {
            peg$currPos = s0;
            s0 = peg$FAILED;
        }
        if (s0 === peg$FAILED) {
            s0 = peg$currPos;
            if (input.charCodeAt(peg$currPos) === 39) {
                s1 = peg$c9;
                peg$currPos++;
            }
            else {
                s1 = peg$FAILED;
                if (peg$silentFails === 0) {
                    peg$fail(peg$e48);
                }
            }
            if (s1 !== peg$FAILED) {
                s2 = peg$parsesingleQuotedStringContents();
                if (input.charCodeAt(peg$currPos) === 39) {
                    s3 = peg$c9;
                    peg$currPos++;
                }
                else {
                    s3 = peg$FAILED;
                    if (peg$silentFails === 0) {
                        peg$fail(peg$e48);
                    }
                }
                if (s3 !== peg$FAILED) {
                    peg$savedPos = s0;
                    s0 = peg$f36(s2);
                }
                else {
                    peg$currPos = s0;
                    s0 = peg$FAILED;
                }
            }
            else {
                peg$currPos = s0;
                s0 = peg$FAILED;
            }
        }
        peg$silentFails--;
        if (s0 === peg$FAILED) {
            s1 = peg$FAILED;
            if (peg$silentFails === 0) {
                peg$fail(peg$e63);
            }
        }
        peg$resultsCache[key] = { nextPos: peg$currPos, result: s0 };
        return s0;
    }
    function peg$parseunquotedString() {
        var s0, s1;
        var key = peg$currPos * 47 + 34;
        var cached = peg$resultsCache[key];
        if (cached) {
            peg$currPos = cached.nextPos;
            return cached.result;
        }
        peg$silentFails++;
        s0 = [];
        s1 = input.charAt(peg$currPos);
        if (peg$r17.test(s1)) {
            peg$currPos++;
        }
        else {
            s1 = peg$FAILED;
            if (peg$silentFails === 0) {
                peg$fail(peg$e65);
            }
        }
        if (s1 !== peg$FAILED) {
            while (s1 !== peg$FAILED) {
                s0.push(s1);
                s1 = input.charAt(peg$currPos);
                if (peg$r17.test(s1)) {
                    peg$currPos++;
                }
                else {
                    s1 = peg$FAILED;
                    if (peg$silentFails === 0) {
                        peg$fail(peg$e65);
                    }
                }
            }
        }
        else {
            s0 = peg$FAILED;
        }
        peg$silentFails--;
        if (s0 === peg$FAILED) {
            s1 = peg$FAILED;
            if (peg$silentFails === 0) {
                peg$fail(peg$e64);
            }
        }
        peg$resultsCache[key] = { nextPos: peg$currPos, result: s0 };
        return s0;
    }
    function peg$parsearguments() {
        var s0, s1, s2, s3, s4, s5, s6, s7;
        var key = peg$currPos * 47 + 35;
        var cached = peg$resultsCache[key];
        if (cached) {
            peg$currPos = cached.nextPos;
            return cached.result;
        }
        peg$silentFails++;
        s0 = peg$currPos;
        s1 = peg$currPos;
        s2 = [];
        s3 = peg$parseliteral();
        while (s3 !== peg$FAILED) {
            s2.push(s3);
            s3 = peg$currPos;
            s4 = peg$currPos;
            s5 = peg$parse_();
            if (input.charCodeAt(peg$currPos) === 44) {
                s6 = peg$c17;
                peg$currPos++;
            }
            else {
                s6 = peg$FAILED;
                if (peg$silentFails === 0) {
                    peg$fail(peg$e67);
                }
            }
            if (s6 !== peg$FAILED) {
                s7 = peg$parse_();
                s5 = [s5, s6, s7];
                s4 = s5;
            }
            else {
                peg$currPos = s4;
                s4 = peg$FAILED;
            }
            if (s4 !== peg$FAILED) {
                s4 = peg$parseliteral();
                if (s4 === peg$FAILED) {
                    peg$currPos = s3;
                    s3 = peg$FAILED;
                }
                else {
                    s3 = s4;
                }
            }
            else {
                s3 = s4;
            }
        }
        if (s2.length < 1) {
            peg$currPos = s1;
            s1 = peg$FAILED;
        }
        else {
            s1 = s2;
        }
        if (s1 !== peg$FAILED) {
            s2 = peg$parse_();
            if (input.charCodeAt(peg$currPos) === 44) {
                s3 = peg$c17;
                peg$currPos++;
            }
            else {
                s3 = peg$FAILED;
                if (peg$silentFails === 0) {
                    peg$fail(peg$e67);
                }
            }
            if (s3 === peg$FAILED) {
                s3 = null;
            }
            peg$savedPos = s0;
            s0 = peg$f37(s1);
        }
        else {
            peg$currPos = s0;
            s0 = peg$FAILED;
        }
        peg$silentFails--;
        if (s0 === peg$FAILED) {
            s1 = peg$FAILED;
            if (peg$silentFails === 0) {
                peg$fail(peg$e66);
            }
        }
        peg$resultsCache[key] = { nextPos: peg$currPos, result: s0 };
        return s0;
    }
    function peg$parseunquotedStringOrBuiltin() {
        var s0, s1, s2, s3, s4, s5, s6, s7, s8;
        var key = peg$currPos * 47 + 36;
        var cached = peg$resultsCache[key];
        if (cached) {
            peg$currPos = cached.nextPos;
            return cached.result;
        }
        peg$silentFails++;
        s0 = peg$currPos;
        s1 = peg$currPos;
        s2 = peg$parseunquotedString();
        if (s2 !== peg$FAILED) {
            s1 = input.substring(s1, peg$currPos);
        }
        else {
            s1 = s2;
        }
        if (s1 !== peg$FAILED) {
            s2 = peg$parse_();
            s3 = peg$currPos;
            if (input.charCodeAt(peg$currPos) === 40) {
                s4 = peg$c18;
                peg$currPos++;
            }
            else {
                s4 = peg$FAILED;
                if (peg$silentFails === 0) {
                    peg$fail(peg$e69);
                }
            }
            if (s4 !== peg$FAILED) {
                s5 = peg$parse_();
                s6 = peg$parsearguments();
                if (s6 === peg$FAILED) {
                    s6 = null;
                }
                s7 = peg$parse_();
                if (input.charCodeAt(peg$currPos) === 41) {
                    s8 = peg$c19;
                    peg$currPos++;
                }
                else {
                    s8 = peg$FAILED;
                    if (peg$silentFails === 0) {
                        peg$fail(peg$e70);
                    }
                }
                if (s8 !== peg$FAILED) {
                    peg$savedPos = s3;
                    s3 = peg$f38(s1, s6);
                }
                else {
                    peg$currPos = s3;
                    s3 = peg$FAILED;
                }
            }
            else {
                peg$currPos = s3;
                s3 = peg$FAILED;
            }
            if (s3 === peg$FAILED) {
                s3 = null;
            }
            peg$savedPos = s0;
            s0 = peg$f39(s1, s3);
        }
        else {
            peg$currPos = s0;
            s0 = peg$FAILED;
        }
        peg$silentFails--;
        if (s0 === peg$FAILED) {
            s1 = peg$FAILED;
            if (peg$silentFails === 0) {
                peg$fail(peg$e68);
            }
        }
        peg$resultsCache[key] = { nextPos: peg$currPos, result: s0 };
        return s0;
    }
    function peg$parsemap() {
        var s0;
        var key = peg$currPos * 47 + 37;
        var cached = peg$resultsCache[key];
        if (cached) {
            peg$currPos = cached.nextPos;
            return cached.result;
        }
        s0 = input.charAt(peg$currPos);
        if (peg$r18.test(s0)) {
            peg$currPos++;
        }
        else {
            s0 = peg$FAILED;
            if (peg$silentFails === 0) {
                peg$fail(peg$e71);
            }
        }
        peg$resultsCache[key] = { nextPos: peg$currPos, result: s0 };
        return s0;
    }
    function peg$parsemapKey() {
        var s0, s1;
        var key = peg$currPos * 47 + 38;
        var cached = peg$resultsCache[key];
        if (cached) {
            peg$currPos = cached.nextPos;
            return cached.result;
        }
        peg$silentFails++;
        s0 = peg$parsequotedStringLiteral();
        if (s0 === peg$FAILED) {
            s0 = peg$currPos;
            s1 = peg$parseunquotedString();
            if (s1 !== peg$FAILED) {
                s0 = input.substring(s0, peg$currPos);
            }
            else {
                s0 = s1;
            }
        }
        peg$silentFails--;
        if (s0 === peg$FAILED) {
            s1 = peg$FAILED;
            if (peg$silentFails === 0) {
                peg$fail(peg$e72);
            }
        }
        peg$resultsCache[key] = { nextPos: peg$currPos, result: s0 };
        return s0;
    }
    function peg$parsemapEntry() {
        var s0, s1, s2, s3, s4, s5;
        var key = peg$currPos * 47 + 39;
        var cached = peg$resultsCache[key];
        if (cached) {
            peg$currPos = cached.nextPos;
            return cached.result;
        }
        peg$silentFails++;
        s0 = peg$currPos;
        s1 = peg$parsemapKey();
        if (s1 !== peg$FAILED) {
            s2 = peg$parse_();
            if (input.charCodeAt(peg$currPos) === 58) {
                s3 = peg$c20;
                peg$currPos++;
            }
            else {
                s3 = peg$FAILED;
                if (peg$silentFails === 0) {
                    peg$fail(peg$e74);
                }
            }
            if (s3 !== peg$FAILED) {
                s4 = peg$parse_();
                s5 = peg$parseliteral();
                if (s5 !== peg$FAILED) {
                    peg$savedPos = s0;
                    s0 = peg$f40(s1, s5);
                }
                else {
                    peg$currPos = s0;
                    s0 = peg$FAILED;
                }
            }
            else {
                peg$currPos = s0;
                s0 = peg$FAILED;
            }
        }
        else {
            peg$currPos = s0;
            s0 = peg$FAILED;
        }
        peg$silentFails--;
        if (s0 === peg$FAILED) {
            s1 = peg$FAILED;
            if (peg$silentFails === 0) {
                peg$fail(peg$e73);
            }
        }
        peg$resultsCache[key] = { nextPos: peg$currPos, result: s0 };
        return s0;
    }
    function peg$parsemapEntries() {
        var s0, s1, s2, s3, s4, s5, s6, s7;
        var key = peg$currPos * 47 + 40;
        var cached = peg$resultsCache[key];
        if (cached) {
            peg$currPos = cached.nextPos;
            return cached.result;
        }
        peg$silentFails++;
        s0 = peg$currPos;
        s1 = peg$currPos;
        s2 = [];
        s3 = peg$parsemapEntry();
        while (s3 !== peg$FAILED) {
            s2.push(s3);
            s3 = peg$currPos;
            s4 = peg$currPos;
            s5 = peg$parse_();
            if (input.charCodeAt(peg$currPos) === 44) {
                s6 = peg$c17;
                peg$currPos++;
            }
            else {
                s6 = peg$FAILED;
                if (peg$silentFails === 0) {
                    peg$fail(peg$e67);
                }
            }
            if (s6 !== peg$FAILED) {
                s7 = peg$parse_();
                s5 = [s5, s6, s7];
                s4 = s5;
            }
            else {
                peg$currPos = s4;
                s4 = peg$FAILED;
            }
            if (s4 !== peg$FAILED) {
                s4 = peg$parsemapEntry();
                if (s4 === peg$FAILED) {
                    peg$currPos = s3;
                    s3 = peg$FAILED;
                }
                else {
                    s3 = s4;
                }
            }
            else {
                s3 = s4;
            }
        }
        if (s2.length < 1) {
            peg$currPos = s1;
            s1 = peg$FAILED;
        }
        else {
            s1 = s2;
        }
        if (s1 !== peg$FAILED) {
            s2 = peg$parse_();
            if (input.charCodeAt(peg$currPos) === 44) {
                s3 = peg$c17;
                peg$currPos++;
            }
            else {
                s3 = peg$FAILED;
                if (peg$silentFails === 0) {
                    peg$fail(peg$e67);
                }
            }
            if (s3 === peg$FAILED) {
                s3 = null;
            }
            peg$savedPos = s0;
            s0 = peg$f41(s1);
        }
        else {
            peg$currPos = s0;
            s0 = peg$FAILED;
        }
        peg$silentFails--;
        if (s0 === peg$FAILED) {
            s1 = peg$FAILED;
            if (peg$silentFails === 0) {
                peg$fail(peg$e75);
            }
        }
        peg$resultsCache[key] = { nextPos: peg$currPos, result: s0 };
        return s0;
    }
    function peg$parsemapLiteral() {
        var s0, s1, s2, s3, s4, s5;
        var key = peg$currPos * 47 + 41;
        var cached = peg$resultsCache[key];
        if (cached) {
            peg$currPos = cached.nextPos;
            return cached.result;
        }
        peg$silentFails++;
        s0 = peg$currPos;
        if (input.charCodeAt(peg$currPos) === 123) {
            s1 = peg$c15;
            peg$currPos++;
        }
        else {
            s1 = peg$FAILED;
            if (peg$silentFails === 0) {
                peg$fail(peg$e54);
            }
        }
        if (s1 !== peg$FAILED) {
            s2 = peg$parse_();
            s3 = peg$parsemapEntries();
            if (s3 === peg$FAILED) {
                s3 = null;
            }
            s4 = peg$parse_();
            if (input.charCodeAt(peg$currPos) === 125) {
                s5 = peg$c16;
                peg$currPos++;
            }
            else {
                s5 = peg$FAILED;
                if (peg$silentFails === 0) {
                    peg$fail(peg$e55);
                }
            }
            if (s5 !== peg$FAILED) {
                peg$savedPos = s0;
                s0 = peg$f42(s3);
            }
            else {
                peg$currPos = s0;
                s0 = peg$FAILED;
            }
        }
        else {
            peg$currPos = s0;
            s0 = peg$FAILED;
        }
        peg$silentFails--;
        if (s0 === peg$FAILED) {
            s1 = peg$FAILED;
            if (peg$silentFails === 0) {
                peg$fail(peg$e76);
            }
        }
        peg$resultsCache[key] = { nextPos: peg$currPos, result: s0 };
        return s0;
    }
    function peg$parselist() {
        var s0;
        var key = peg$currPos * 47 + 42;
        var cached = peg$resultsCache[key];
        if (cached) {
            peg$currPos = cached.nextPos;
            return cached.result;
        }
        s0 = input.charAt(peg$currPos);
        if (peg$r19.test(s0)) {
            peg$currPos++;
        }
        else {
            s0 = peg$FAILED;
            if (peg$silentFails === 0) {
                peg$fail(peg$e77);
            }
        }
        peg$resultsCache[key] = { nextPos: peg$currPos, result: s0 };
        return s0;
    }
    function peg$parselistEntries() {
        var s0, s1, s2, s3, s4, s5, s6, s7;
        var key = peg$currPos * 47 + 43;
        var cached = peg$resultsCache[key];
        if (cached) {
            peg$currPos = cached.nextPos;
            return cached.result;
        }
        peg$silentFails++;
        s0 = peg$currPos;
        s1 = peg$currPos;
        s2 = [];
        s3 = peg$parseliteral();
        while (s3 !== peg$FAILED) {
            s2.push(s3);
            s3 = peg$currPos;
            s4 = peg$currPos;
            s5 = peg$parse_();
            if (input.charCodeAt(peg$currPos) === 44) {
                s6 = peg$c17;
                peg$currPos++;
            }
            else {
                s6 = peg$FAILED;
                if (peg$silentFails === 0) {
                    peg$fail(peg$e67);
                }
            }
            if (s6 !== peg$FAILED) {
                s7 = peg$parse_();
                s5 = [s5, s6, s7];
                s4 = s5;
            }
            else {
                peg$currPos = s4;
                s4 = peg$FAILED;
            }
            if (s4 !== peg$FAILED) {
                s4 = peg$parseliteral();
                if (s4 === peg$FAILED) {
                    peg$currPos = s3;
                    s3 = peg$FAILED;
                }
                else {
                    s3 = s4;
                }
            }
            else {
                s3 = s4;
            }
        }
        if (s2.length < 1) {
            peg$currPos = s1;
            s1 = peg$FAILED;
        }
        else {
            s1 = s2;
        }
        if (s1 !== peg$FAILED) {
            s2 = peg$parse_();
            if (input.charCodeAt(peg$currPos) === 44) {
                s3 = peg$c17;
                peg$currPos++;
            }
            else {
                s3 = peg$FAILED;
                if (peg$silentFails === 0) {
                    peg$fail(peg$e67);
                }
            }
            if (s3 === peg$FAILED) {
                s3 = null;
            }
            peg$savedPos = s0;
            s0 = peg$f43(s1);
        }
        else {
            peg$currPos = s0;
            s0 = peg$FAILED;
        }
        peg$silentFails--;
        if (s0 === peg$FAILED) {
            s1 = peg$FAILED;
            if (peg$silentFails === 0) {
                peg$fail(peg$e78);
            }
        }
        peg$resultsCache[key] = { nextPos: peg$currPos, result: s0 };
        return s0;
    }
    function peg$parsearrayPrefix() {
        var s0, s1;
        var key = peg$currPos * 47 + 44;
        var cached = peg$resultsCache[key];
        if (cached) {
            peg$currPos = cached.nextPos;
            return cached.result;
        }
        peg$silentFails++;
        s0 = input.charAt(peg$currPos);
        if (peg$r20.test(s0)) {
            peg$currPos++;
        }
        else {
            s0 = peg$FAILED;
            if (peg$silentFails === 0) {
                peg$fail(peg$e80);
            }
        }
        peg$silentFails--;
        if (s0 === peg$FAILED) {
            s1 = peg$FAILED;
            if (peg$silentFails === 0) {
                peg$fail(peg$e79);
            }
        }
        peg$resultsCache[key] = { nextPos: peg$currPos, result: s0 };
        return s0;
    }
    function peg$parseintArrayEntries() {
        var s0, s1, s2, s3, s4, s5, s6, s7;
        var key = peg$currPos * 47 + 45;
        var cached = peg$resultsCache[key];
        if (cached) {
            peg$currPos = cached.nextPos;
            return cached.result;
        }
        peg$silentFails++;
        s0 = peg$currPos;
        s1 = peg$currPos;
        s2 = [];
        s3 = peg$parseinteger();
        while (s3 !== peg$FAILED) {
            s2.push(s3);
            s3 = peg$currPos;
            s4 = peg$currPos;
            s5 = peg$parse_();
            if (input.charCodeAt(peg$currPos) === 44) {
                s6 = peg$c17;
                peg$currPos++;
            }
            else {
                s6 = peg$FAILED;
                if (peg$silentFails === 0) {
                    peg$fail(peg$e67);
                }
            }
            if (s6 !== peg$FAILED) {
                s7 = peg$parse_();
                s5 = [s5, s6, s7];
                s4 = s5;
            }
            else {
                peg$currPos = s4;
                s4 = peg$FAILED;
            }
            if (s4 !== peg$FAILED) {
                s4 = peg$parseinteger();
                if (s4 === peg$FAILED) {
                    peg$currPos = s3;
                    s3 = peg$FAILED;
                }
                else {
                    s3 = s4;
                }
            }
            else {
                s3 = s4;
            }
        }
        if (s2.length < 1) {
            peg$currPos = s1;
            s1 = peg$FAILED;
        }
        else {
            s1 = s2;
        }
        if (s1 !== peg$FAILED) {
            s2 = peg$parse_();
            if (input.charCodeAt(peg$currPos) === 44) {
                s3 = peg$c17;
                peg$currPos++;
            }
            else {
                s3 = peg$FAILED;
                if (peg$silentFails === 0) {
                    peg$fail(peg$e67);
                }
            }
            if (s3 === peg$FAILED) {
                s3 = null;
            }
            peg$savedPos = s0;
            s0 = peg$f44(s1);
        }
        else {
            peg$currPos = s0;
            s0 = peg$FAILED;
        }
        peg$silentFails--;
        if (s0 === peg$FAILED) {
            s1 = peg$FAILED;
            if (peg$silentFails === 0) {
                peg$fail(peg$e81);
            }
        }
        peg$resultsCache[key] = { nextPos: peg$currPos, result: s0 };
        return s0;
    }
    function peg$parselistLiteral() {
        var s0, s1, s2, s3, s4, s5, s6, s7, s8;
        var key = peg$currPos * 47 + 46;
        var cached = peg$resultsCache[key];
        if (cached) {
            peg$currPos = cached.nextPos;
            return cached.result;
        }
        peg$silentFails++;
        s0 = peg$currPos;
        if (input.charCodeAt(peg$currPos) === 91) {
            s1 = peg$c21;
            peg$currPos++;
        }
        else {
            s1 = peg$FAILED;
            if (peg$silentFails === 0) {
                peg$fail(peg$e83);
            }
        }
        if (s1 !== peg$FAILED) {
            s2 = peg$parse_();
            s3 = peg$currPos;
            s4 = peg$parsearrayPrefix();
            if (s4 !== peg$FAILED) {
                s5 = peg$parse_();
                if (input.charCodeAt(peg$currPos) === 59) {
                    s6 = peg$c22;
                    peg$currPos++;
                }
                else {
                    s6 = peg$FAILED;
                    if (peg$silentFails === 0) {
                        peg$fail(peg$e84);
                    }
                }
                if (s6 !== peg$FAILED) {
                    s7 = peg$parse_();
                    s8 = peg$parseintArrayEntries();
                    if (s8 !== peg$FAILED) {
                        peg$savedPos = s3;
                        s3 = peg$f45(s4, s8);
                    }
                    else {
                        peg$currPos = s3;
                        s3 = peg$FAILED;
                    }
                }
                else {
                    peg$currPos = s3;
                    s3 = peg$FAILED;
                }
            }
            else {
                peg$currPos = s3;
                s3 = peg$FAILED;
            }
            if (s3 === peg$FAILED) {
                s3 = peg$parselistEntries();
            }
            if (s3 === peg$FAILED) {
                s3 = null;
            }
            s4 = peg$parse_();
            if (input.charCodeAt(peg$currPos) === 93) {
                s5 = peg$c23;
                peg$currPos++;
            }
            else {
                s5 = peg$FAILED;
                if (peg$silentFails === 0) {
                    peg$fail(peg$e85);
                }
            }
            if (s5 !== peg$FAILED) {
                peg$savedPos = s0;
                s0 = peg$f46(s3);
            }
            else {
                peg$currPos = s0;
                s0 = peg$FAILED;
            }
        }
        else {
            peg$currPos = s0;
            s0 = peg$FAILED;
        }
        peg$silentFails--;
        if (s0 === peg$FAILED) {
            s1 = peg$FAILED;
            if (peg$silentFails === 0) {
                peg$fail(peg$e82);
            }
        }
        peg$resultsCache[key] = { nextPos: peg$currPos, result: s0 };
        return s0;
    }
    peg$result = peg$startRuleFunction();
    if (options.peg$library) {
        return /** @type {any} */ ({
            peg$result,
            peg$currPos,
            peg$FAILED,
            peg$maxFailExpected,
            peg$maxFailPos
        });
    }
    if (peg$result !== peg$FAILED && peg$currPos === input.length) {
        return peg$result;
    }
    else {
        if (peg$result !== peg$FAILED && peg$currPos < input.length) {
            peg$fail(peg$endExpectation());
        }
        throw peg$buildStructuredError(peg$maxFailExpected, peg$maxFailPos < input.length ? input.charAt(peg$maxFailPos) : null, peg$maxFailPos < input.length
            ? peg$computeLocation(peg$maxFailPos, peg$maxFailPos + 1)
            : peg$computeLocation(peg$maxFailPos, peg$maxFailPos));
    }
}
const peg$allowedStartRules = [
    "literal"
];
export { peg$allowedStartRules as StartRules, peg$SyntaxError as SyntaxError, peg$parse as parse };
//# sourceMappingURL=snbt-parser.gen.js.map